import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { HttpService } from './http.service';
import { delay, mergeMap, repeatWhen, retryWhen, take, tap } from 'rxjs/operators';
import { AlarmDict } from '../type/employee.interface';
import { ResponseSettings } from '../type/auth.interface';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  update = false;
  settings$: BehaviorSubject<ResponseSettings | null> = new BehaviorSubject<ResponseSettings | null>(null);

  constructor(private http: HttpService) {}

  init() {
    if (!this.update) {
      this.updateSettings();
    }
  }
  updateSettings() {
    /*this.http.getSettings()
    .pipe(take(1),
    retryWhen((errors: Observable<any>) => errors.pipe(
      delay(1000)
    ))
    ).subscribe(x => {
        this.settings$.next(x);
        this.update = true;
    });*/
  }

  setSettings(data: ResponseSettings) {
    /*return this.http.setSettings(data).pipe(tap(x => {
      this.settings$.next(x);
    }))*/
  }

}

